

































import { Component, Prop, Vue } from 'vue-property-decorator'
import Hi from '@/components/Hi.vue'
import ProjectGrid from '@/components/ProjectGrid.vue'
import ProjectCard from '@/components/ProjectCard.vue'

import { Project } from '../types'

@Component({ components: { Hi, ProjectGrid, ProjectCard } })
export default class extends Vue {
  get ctoProjects() {
    return this.$store.state.projects.filter((p: Project) => p.category === 'cto')
  }
  get projects() {
    return this.$store.state.projects.filter((p: Project) => p.category === 'project')
  }
  get speaking() {
    return this.$store.state.speaking.reverse()
  }
  get mentorship() {
    return this.$store.state.mentorship
  }
}
